export function range(min, max, step) {
    var result = [];
    for (var i = min; i <= max; i += step) {
        result.push(i);
    }
    return result;
}
